import { User } from "@fairfleet/geotab";

export function getUserEmail(user: User) {
  return user.name;
}
